export type ContentZoom = 'small' | 'medium' | 'large';

const KEY = 'lex-content-zoom';
const EVENT = 'lex-content-zoom-change';

export function getContentZoom(): ContentZoom {
  return (localStorage.getItem(KEY) as ContentZoom) ?? 'small';
}

export function setContentZoom(z: ContentZoom): void {
  localStorage.setItem(KEY, z);
  window.dispatchEvent(new Event(EVENT));
}

export const ZOOM_VALUES: Record<ContentZoom, number> = {
  small: 1,
  medium: 1.2,
  large: 1.4,
};

export const ZOOM_LABELS: Record<ContentZoom, string> = {
  small: 'A',
  medium: 'A',
  large: 'A',
};

export const ZOOM_FONT_SIZES: Record<ContentZoom, number> = {
  small: 12,
  medium: 15,
  large: 18,
};
